import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resetScroll } from '../utils/scrollUtils';

// This component will automatically scroll to top when route changes
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  // Check if we're on privacy or terms page
  const isPrivacyOrTermsPage = pathname === '/privacy' || pathname === '/terms';

  useEffect(() => {
    // Use our utility function for reliable scroll reset across browsers
    const timeoutId = setTimeout(
      () => {
        resetScroll();

        // For critical pages, apply an additional reset with a slight delay
        if (isPrivacyOrTermsPage) {
          setTimeout(resetScroll, 100);
        }
      },
      isPrivacyOrTermsPage ? 10 : 0,
    );

    return () => clearTimeout(timeoutId);
  }, [pathname, isPrivacyOrTermsPage]);

  return null; // This component doesn't render anything
};
